import { api } from './client';

/**
 * Коды сбоя проверки обновлений. Backend отдаёт машинный код, а не текст
 * ошибки Go: текст не локализован, не является контрактом и может нести
 * внутренние детали (вывод резолвера, цепочку TLS, адрес прокси).
 */
export type UpdateCheckErrorCode =
  | 'unreachable'
  | 'bad_status'
  | 'bad_response'
  | 'invalid_format';

export interface UpdateStatus {
  /** false, если оператор не включил проверку (UPDATE_CHECK_ENABLED). */
  enabled: boolean;
  current_version: string;
  latest_version?: string;
  update_available: boolean;
  release_url?: string;
  released_at?: string;
  /** Время последней УСПЕШНОЙ проверки, UTC. Отсутствует, если её не было. */
  checked_at?: string;
  last_error_code?: UpdateCheckErrorCode;
}

/**
 * Эндпоинт admin-only: «инсталляция на N релизов позади» — разведданные для
 * держателя низкопривилегированного аккаунта. Для не-админа запрос вернёт 403,
 * и вызывающий хук просто ничего не покажет.
 */
export async function fetchUpdateStatus(): Promise<UpdateStatus> {
  const { data } = await api.get('/version/update');
  return (data.data ?? data) as UpdateStatus;
}

/**
 * Ссылка на релиз пропускается только со схемой http(s).
 *
 * Значение приходит из манифеста, то есть из внешнего источника, и становится
 * href в админском UI — `javascript:` там был бы XSS-примитивом. Backend уже
 * применяет тот же allowlist, но фронт не полагается на это: правило дешёвое, а
 * доверять одному фильтру на всю цепочку — ровно тот случай, когда его правка
 * на другом конце молча открывает дыру.
 */
export function safeReleaseUrl(raw?: string): string | undefined {
  if (!raw) return undefined;
  const lower = raw.toLowerCase();
  return lower.startsWith('http://') || lower.startsWith('https://') ? raw : undefined;
}
